import { VideoAspectRatio } from 'common/types/entities/VideoInterface'

const aspectRatioPadding: Record<VideoAspectRatio, number> = {
  '16:9': 56.25,
  '9:16': 177.78,
  '1:1': 100,
  '4:3': 75,
}

export const getPaddingForRatio = (ratio?: VideoAspectRatio): number => {
  if (ratio && ratio in aspectRatioPadding) {
    return aspectRatioPadding[ratio]
  }
  return aspectRatioPadding['16:9']
}
